import { FormattedMessage } from 'react-intl';

import SolidCheckCircle from '@/assets/icons/solid-check-circle.svg';
import { ChannelIcon } from '@/components/ui/channel-icon';
import { Typography } from '@/components/ui/typography';

interface SuccessProps {
  name: string;
  logoSquareUrl: string | null;
  logoRectangleUrl: string | null;
}

export function Success({
  name,
  logoSquareUrl,
  logoRectangleUrl,
}: SuccessProps) {
  return (
    <div className="border-fx-neutral-200 bg-fx-neutral-50 flex flex-col items-center justify-center gap-2 self-stretch rounded-sm border px-10 py-4">
      <img src={SolidCheckCircle} alt="" aria-hidden />
      <div className="flex h-6 items-center justify-center gap-3 rounded-full bg-green-50 px-3">
        <ChannelIcon
          channelName={name}
          logoSquareUrl={logoSquareUrl}
          logoRectangleUrl={logoRectangleUrl}
          variant="large"
        />
      </div>
      <div className="flex flex-col items-center gap-2 self-stretch text-center">
        <Typography variant="small2" className="text-center">
          <FormattedMessage
            defaultMessage="Contract added successfully"
            description="Add contract sheet: success state heading after contract is created"
          />
        </Typography>
        <Typography variant="subtitle1" className="text-center">
          <FormattedMessage
            defaultMessage="{contract} is now active and available to your team when posting jobs. It will appear in the <b>Contracts</b> section."
            description="Add contract sheet: success state body; {contract} is the job channel name; Contracts is bold"
            values={{ contract: name }}
          />
        </Typography>
      </div>
    </div>
  );
}
